export default __webpack_public_path__ + "static/edu-dark-387f6919948434b8b0d16addd1db5581.svg";